import React, { Component } from "react";
import { Link, withRouter } from 'react-router-dom';
import Input from "../common/Input";
import * as Icon from "react-feather";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../config';
import CustomLoader from '../common/Loader';
import { logActivity } from '../../services/utilService';
import { Tab, Tabs } from "react-bootstrap";
import { AddReactionTwoTone } from "@mui/icons-material";
import AddReport from "./AddReport";

class ReportSettings extends Component {


    constructor(props) {
        super(props);

        this.state = {
            rowData: this.props.history.location.state.rowData || [],
            loading: false
        };

    }

    async componentDidMount() {
        console.log('Reptjkrgn', this.state, this.props);
    }

    render() {
        const { rowData } = this.state;

        const loading = (<CustomLoader loading={this.state.loading} />);
        try {
            if (this.state.loading) { return loading }
            else {
                return (
                    <React.Fragment>
                        <header className='page-header page-header-dark bg-gradient-primary-to-secondary'>
                            <div className='container'>
                                <div className='page-header-content pt-4'>
                                    <div className='row align-items-center justify-content-between'>
                                        <div className='col-auto mt-4'>
                                            <h1 className='page-header-title'>
                                                <div className='page-header-icon'>
                                                    <Icon.Settings />
                                                </div>
                                                Report Settings
                                            </h1>
                                            <div className='page-header-subtitle'>
                                                Configure your Report here.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ol className="breadcrumb mb-0 mt-4">
                                <li className="breadcrumb-item">
                                    <Link to={{ pathname: "/ReportBuilder/" }}>Reports</Link>
                                </li>
                                <li className="breadcrumb-item active">{rowData[1]}</li>
                            </ol>
                        </header>
                        <div className="container mt-2">
                            <Tabs defaultActiveKey="addReport" variant="pills" className="rounded-0">
                                <Tab eventKey="addReport" title="Basic">
                                    <div className="card">
                                        <AddReport preloadData={rowData} />
                                    </div>
                                </Tab>
                                <Tab eventKey="s" title="Advanced" disabled={false}>
                                    <div className="card">
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </React.Fragment >
                );
            }
        }
        catch (e) {
            console.error('Error loading Report BUilder: ', e);
            return (loading);
        }
    }
}

export default withRouter(ReportSettings);